/**
 * Zod singleton
 * This is a singleton instance of the Zod library, which is used for schema validation.
 * This is done as we currently edit the zod instance with extendZodWithOpenApi so we need one instance
 * Once https://github.com/asteasolutions/zod-to-openapi/issues/324 is implemented, this will not matter
 * anymore as we will be able to use .meta instead of .openapi for parameter definitions
 */

import * as z from "zod";

import { extendZodWithOpenApi } from "@asteasolutions/zod-to-openapi";

extendZodWithOpenApi(z);

export default z;
